import { FC, useContext, useEffect, useState, ChangeEvent } from "react";
import { useParams } from "react-router-dom";
import { Program } from "@project-serum/anchor";
import { TweeterDapp } from "../types/tweeter_dapp";
import { ConnectionContext } from "../contexts/ConnectionProviderContext";
import { LikeContext } from "../contexts/LikesContext";
import setTweetsWithUserLike from "../utils/Tweets";
import * as bs58 from "bs58";
import TweetsContainer from "../utils/TweetsContainer";

const Topics: FC = () => {
  const params = useParams();
  const [topic, setTopic] = useState<String | undefined>("");
  const [tweetsByTopic, setTweetsByTopic] = useState<any | null>([]);
  const [fetchTweets, setFetchTweets] = useState<Boolean>(false);
  const { workSpace }: any = useContext(ConnectionContext);
  const { allLikes, userLikes}: any = useContext(LikeContext);
  const program = workSpace.program as Program<TweeterDapp>;
  const wallet = workSpace.wallet;

  const topicHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const topic = e.target.value;
    // console.log("TOPIC", topic);
    setTopic(topic);
  };

  const tweetButtonHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    // console.log("clikcced");

    try {
      if (!topic?.length) {
        // console.log("TOPIC NOT FOUND");
        return;
      }
      (async () => {
        const tweets = await program.account.tweet.all([
          {
            memcmp: {
              offset: 8 + 32 + 8 + 4,
              bytes: bs58.encode(Buffer.from(topic)),
            },
          },
        ]);
        // console.log("TWEETS BY TOPIC", tweets);
        const tweetsWithUserLikes = setTweetsWithUserLike(allLikes,tweets,userLikes);
        setTweetsByTopic(tweetsWithUserLikes);
        setFetchTweets(true);
        setTopic("");
      })();
    } catch (error) {
      console.log("Error in Topics", error);
    }
  };

  useEffect(() => {
    // console.log("PARAMS TOPIC", params.topics)
    if (!params.topics) {
      return;
    } else {
      const topic: String | undefined = params.topics;
      setTopic(topic);
    }
  }, [topic]);

  return (
    <main className=" pt-5 gap-4 col-start-3 col-span-12 px-2 md:row-start-7 md:col-start-3 md:col-span-7 md:pt-8 md:items-end xl:col-start-5 xl:col-span-4">
      <h1 className="text-center pb-2 font-medium text-lg">Topics Page</h1>
      <form className=" place-self-center rounded-md border-2 border-gray-300 p-4">
        <fieldset className="mb-2 flex flex-col items-center space-x-4 md:flex-row md:items-baseline md:justify-center">
          <input
            onChange={topicHandler}
            type="text"
            className="bg-gray-100 p-2 mt-1 w-60 sm:w-96 focus:outline-none rounded-2xl text-sm md:w-60 md:text-base lg:w-80"
            defaultValue={topic ? topic.toString() : ""}
            placeholder="topic eg. football"
            name="topic"
          ></input>
            <button
              onClick={tweetButtonHandler}
              className="bg-blue-400 text-white p-2 mt-4 mx-auto hover:bg-blue-500 rounded-md w-24 min-w-max text-sm md:text-base"
              type="submit"
            >
              Search By Topic
            </button>
        </fieldset>
      </form>
      {fetchTweets && tweetsByTopic.length === 0 && <h1 className="text-center text-xl font-extrabold text-blue-400">No tweets with this topic yet!</h1>}
      <TweetsContainer tweets={tweetsByTopic} />
    </main>
  );
};

export default Topics;
